import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import IntersectAnimate from 'alpine-intersect-animate';
import collapse from '@alpinejs/collapse';
import Swiper, { Navigation, Pagination, Autoplay, Scrollbar, Mousewheel, Manipulation, EffectFade, FreeMode } from 'swiper';
import { OpeningHours, WeekDays } from '@phoenix344/opening-hours';
import 'swiper/css/bundle';
import axios from 'axios';
import qs from 'qs';
import Datepicker from 'flowbite-datepicker/Datepicker';

window.OpeningHours = OpeningHours;
window.WeekDays = WeekDays;

let ticker = document.querySelectorAll('.ticker');
ticker.forEach(function(el){
    let tickerList = el.querySelector('.ticker--list');
    let tickerClone = tickerList.cloneNode(true);
    el.append(tickerClone);
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
});

window.addEventListener('load', () => {
    if(document.querySelector('body.slug--our-stores')) {
        if(window.location.hash) {
            const hash = window.location.hash.substr(1);

            const element = document.querySelector('#' + hash);

            window.scroll({
                behavior: "smooth",
                left: 0,
                top: element.offsetTop - 68,
            });
        }
    }

    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    const newsletter_forms = document.querySelectorAll('.newsletter-signup');
    const careers_form = document.querySelector('.careers-form');

    if(newsletter_forms) {

        newsletter_forms.forEach((newsletter_form) => {
            new Datepicker(newsletter_form.querySelector('.js-datepicker'), {
                autohide: true,
                format: 'dd/mm/yyyy'
            });

            // Add real-time validation for the phone input
            const phoneInput = newsletter_form.querySelector('input[name="phone"]');
            if (phoneInput) {
                phoneInput.addEventListener('input', (e) => {
                    let value = e.target.value;
                    // Allow digits and an optional leading '+'
                    let cleanedValue = value.replace(/[^\d+]/g, '');
                    // Ensure '+' only appears at the beginning if present
                    if (cleanedValue.indexOf('+') > 0) {
                        cleanedValue = '+' + cleanedValue.replace(/\+/g, '');
                    }
                    // Prevent multiple leading '+'
                    if (cleanedValue.startsWith('++')) {
                        cleanedValue = '+' + cleanedValue.substring(2);
                    }
                    // Remove any '+' if it's not the first character
                    cleanedValue = cleanedValue.replace(/(?!^)\+/g, '');

                    e.target.value = cleanedValue;
                });
            }

            // Add auto-formatting for the date input
            const datepickerInput = newsletter_form.querySelector('.js-datepicker');
            if (datepickerInput) {
                datepickerInput.addEventListener('input', (e) => {
                    let value = e.target.value.replace(/\D/g, ''); // Remove non-digits
                    let formattedValue = '';

                    if (value.length > 0) {
                        formattedValue += value.substring(0, 2);
                    }
                    if (value.length > 2) {
                        formattedValue += '/' + value.substring(2, 4);
                    }
                    if (value.length > 4) {
                        formattedValue += '/' + value.substring(4, 8);
                    }

                    // Update the value, restricting to dd/mm/yyyy format length
                    e.target.value = formattedValue.substring(0, 10);
                });
            }

            newsletter_form.addEventListener('submit', (e) => {

                e.preventDefault()

                const errorElement = newsletter_form.parentElement.parentElement.querySelector('.w-full .js-error');
                const successElement = newsletter_form.parentElement.parentElement.querySelector('.js-signup-text');

                // Show some kind of loading state
                const submitButton = newsletter_form.querySelector('button[type="submit"]');
                let originalText = 'Subscribe'; // Default text
                if (submitButton) {
                    originalText = submitButton.innerHTML;
                    submitButton.innerHTML = 'Submitting...';
                    submitButton.disabled = true;
                }

                const formData = Object.fromEntries(new FormData(e.target).entries());

                console.log('Form data being sent:', {
                    email: formData['email'],
                    firstName: formData['first_name'],
                    lastName: formData['last_name'],
                    phone: formData['phone'],
                    birthdate: formData['birthdate']
                });

                // Send form data to Statamic's form endpoint
                axios.post(newsletter_form.action, new FormData(newsletter_form))
                    .then(function (response) {
                        console.log('API response:', response.data);

                        // After successful Statamic form submission, send to Klaviyo
                        axios.post('/subscribe-to-klaviyo', {
                            email: formData['email'],
                            first_name: formData['first_name'],
                            last_name: formData['last_name'],
                            phone: formData['phone'],
                            birthdate: formData['birthdate'],
                            source: 'Newsletter Form'
                        })
                        .then(function(klaviyoResponse) {
                            console.log('Klaviyo subscription successful:', klaviyoResponse.data);
                        })
                        .catch(function(klaviyoError) {
                            console.log('Klaviyo subscription error:', klaviyoError);
                            // Still continue with success message since Statamic form saved
                        })
                        .finally(function() {
                            if (submitButton) {
                                submitButton.disabled = false;
                                submitButton.innerHTML = originalText;
                            }

                            errorElement.classList.add('hidden');
                            newsletter_form.classList.add('hidden');
                            successElement.innerHTML = 'THANKS FOR JOINING US, KEEP A LOOK OUT FOR US IN YOUR INBOX'
                            successElement.classList.add('!text-center');
                        });
                    })
                    .catch(function (error) {
                        if (submitButton) {
                            submitButton.disabled = false;
                            submitButton.innerHTML = originalText;
                        }

                        console.log('Error details:', error);

                        if (error.response) {
                            console.log('Error response data:', error.response.data);
                        }

                        errorElement.classList.remove('hidden');
                        errorElement.innerHTML = 'There has been an error. Please try again.';
                    });
            });
        });
    }

    if(careers_form) {

        window.setTimeout(()=>{
            careers_form.addEventListener('submit', (e) => {

                e.preventDefault()

                const errorElement = careers_form.querySelector('.js-error');
                const successElement = careers_form.querySelector('.js-signup-text');

                careers_form.querySelector('.fields').classList.add('opacity-50');
                careers_form.querySelector('.submit-button').innerHTML = 'Submitting...';

                axios.post(careers_form.action, new FormData(careers_form))
                    .then(response => {
                        if (response.data.success) {
                            errorElement.classList.add('hidden');
                            careers_form.querySelector('.fields').classList.remove('opacity-50');
                            careers_form.querySelector('.fields').classList.add('hidden');
                            careers_form.parentElement.querySelector('.js-intro').classList.add('hidden');
                            careers_form.querySelector('.submit-button').classList.add('hidden');
                            successElement.innerHTML = 'SUCCESS!<br><br>Thanks for contacting us, keep a look out for us in your mail box'
                            successElement.classList.add('!text-center');
                        }
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            const message = error.response.data.errors[0];
                            careers_form.querySelector('.fields').classList.remove('opacity-50');
                            careers_form.querySelector('.submit-button').innerHTML = 'Submit';
                            errorElement.classList.remove('hidden');
                            errorElement.innerHTML = message;
                            console.log(message);
                        }
                    });
            })
        },1000)

    }

});

Alpine.data('checkboxExpander', () => ({
    expanded: false,
}));



Alpine.data('pageSettings', () => ({
    isPageReady: false,
    isNavOpen: false,
}));


// Single Image Sliders
Alpine.data('homeSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Autoplay, Pagination, Navigation, EffectFade],
            effect: "fade",
            loop: true,
            slidesPerView: 1,
            loopAdditionalSlides: 4,
            navigation: {
                nextEl: '.next-button',
                prevEl: '.prev-button',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            autoplay: {
                delay: 2000,
                pauseOnMouseEnter: true,
            },
        });
    }
}));

Alpine.data('leftTextCarousel', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Pagination, Navigation, EffectFade],
            loop: true,
            effect: "fade",
            slidesPerView: 1,
            loopAdditionalSlides: 4,
            navigation: {
                nextEl: '.next-button',
                prevEl: '.prev-button',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            autoplay: {
                delay: 3000,
                pauseOnMouseEnter: true,
            },
        });
    }
}));

Alpine.data('productSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Pagination, Navigation, EffectFade],
            effect: "fade",
            loop: true,
            slidesPerView: 1,
            navigation: {
                nextEl: '.next-button',
                prevEl: '.prev-button',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            autoplay: {
                delay: 3000,
                pauseOnMouseEnter: true,
            },
        });
    }
}));

Alpine.data('stampSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Pagination, Autoplay, EffectFade],
            loop: true,
            effect: 'fade',
            slidesPerView: 1,
            loopAdditionalSlides: 4,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            autoplay: {
                delay: 2000,
            },
        });
    }
}));


// Multiple image sliders
Alpine.data('relatedSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            loop: true,
            breakpoints: {
                // when window width is >= 480px
                480: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                  centeredSlides: false,
                },
                // when window width is >= 640px
                640: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                  centeredSlides: true,
                }
            }
        });
    }
}));

Alpine.data('aboutSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Autoplay],
            loop: true,
            slidesPerView: 1.5,
            speed: 5000,
            spaceBetween: 18,
            freeMode: true,
            autoplay: {
                delay: 0,
                pauseOnMouseEnter: false,
            },
            breakpoints: {
                // when window width is >= 640px
                767: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                }
            }
        });
    }
}));

Alpine.data('cakesSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Autoplay, Navigation],
            loop: true,
            slidesPerView: 1.5,
            speed: 1000,
            spaceBetween: 18,
            navigation: {
                nextEl: '.next-button',
                prevEl: '.prev-button',
            },
            autoplay: {
                delay: 2000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                // when window width is >= 640px
                767: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                }
            }
        });
    }
}));

Alpine.data('gelatoSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Autoplay],
            allowTouchMove: false,
            loop: true,
            slidesPerView: 1.5,
            speed: 5000,
            spaceBetween: 18,
            autoplay: {
                delay: 0,
            },
            breakpoints: {
                // when window width is >= 640px
                767: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                }
            }
        });
    }
}));

Alpine.plugin(intersect);
Alpine.plugin(IntersectAnimate);
Alpine.plugin(collapse);

window.Alpine = Alpine;
Alpine.start();
